import type { ReactNode } from "react";

export type PillTone = "neutral" | "accent" | "success" | "danger" | "warning";

const TONE_CLASS: Record<PillTone, string> = {
	neutral: "border border-border-soft text-muted",
	accent: "bg-accent-soft text-accent-lav",
	success: "border border-success/40 text-success",
	danger: "border border-danger/40 text-danger",
	warning: "border border-border-soft text-accent-lav-bright",
};

type PillProps = {
	tone?: PillTone;
	children: ReactNode;
};

const Pill: React.FC<PillProps> = ({ tone = "neutral", children }) => (
	<span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-semibold text-xs ${TONE_CLASS[tone]}`}>{children}</span>
);

export default Pill;
